<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Despacho de recorridos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Recorridos</span>
      <span> /</span>
      <span>Despacho de recorridos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px;">
        <div class="md-form mb-0">
          <input
            value=""
            type="text"
            id="nroRecorrido"
            class="form-control"
            placeholder="Nro de recorrido"
            required
            #nroRecorrido
          />
          <label for="nroRecorrido">Nro de recorrido</label>
        </div>
      </div>
      <div class="col d-flex" style="max-width: 300px;">
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
          (click)="seleccionarRecorrido.show()"
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <h6 class="text-info" style="display: contents;">
          Recorrido seleccionado
        </h6>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form mb-0">
          <mdb-date-picker
            [inline]="true"
            name="fechaDesde"
            [placeholder]="'Fecha'"
            required
          ></mdb-date-picker>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle mb-5">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col"><mdb-checkbox></mdb-checkbox></th>
            <th></th>
            <th scope="col">Nro. Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Chofer</th>
            <th scope="col">Monto a cobrar</th>
            <th scope="col">Documentos</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <mdb-checkbox></mdb-checkbox>
            </td>
            <td>
              <button
                mdbBtn
                type="button"
                size="sm"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                (click)="verRecorridos.show()"
                mdbTooltip="Ver"
                placement="right"
              >
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>1212</td>
            <td>GFJH-89</td>
            <td>
              <mdb-select
                [options]="optionsChofer"
                placeholder="Seleccionar chofer"
                [filterEnabled]="true"
              ></mdb-select>
            </td>
            <td>$ 30.000</td>
            <td>3</td>
            <td>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cambiar chofer
              </button>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cargas
              </button>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cobranzas
              </button>
              <button
                mdbBtn
                type="button"
                color="default"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
                disabled
                (click)="despachar.show()"
              >
                Despachado
              </button>
            </td>
          </tr>
          <tr>
            <td><mdb-checkbox></mdb-checkbox></td>
            <td>
              <button
                mdbBtn
                type="button"
                size="sm"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                (click)="verRecorridos.show()"
                mdbTooltip="Ver"
                placement="right"
              >
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>
            </td>
            <td>1212</td>
            <td>GFJH-89</td>
            <td>
              Juan Perez
            </td>
            <td>$ 30.000</td>
            <td>3</td>
            <td>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cambiar chofer
              </button>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cargas
              </button>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
              >
                Cobranzas
              </button>
              <button
                mdbBtn
                type="button"
                color="success"
                mdbWavesEffect
                class="btn text-center"
                size="sm"
                (click)="despachar.show()"
              >
                Despachar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button
      mdbBtn
      type="button"
      color="secondary"
      mdbWavesEffect
      class="btn"
      (click)="despachar.show()"
    >
      Imprimir listados
    </button>
    <button
      mdbBtn
      type="button"
      color="secondary"
      mdbWavesEffect
      class="btn"
      (click)="despachar.show()"
    >
      Descargar Excel
    </button>
    <button
      mdbBtn
      type="button"
      color="secondary"
      mdbWavesEffect
      class="btn"
      (click)="despachar.show()"
    >
      Voucher de despacho
    </button>
    <button
      mdbBtn
      type="button"
      color="success"
      mdbWavesEffect
      class="btn"
      (click)="despachar.show()"
    >
      Despachar
    </button>
  </div>
</div>

<!-- MODAL seleccionarRecorrido -->
<div
  mdbModal
  #seleccionarRecorrido="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar recorrido
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="seleccionarRecorrido.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato">
            <div class="md-form">
              <input
                value=""
                type="text"
                id="descRecorrido"
                class="form-control"
                placeholder="Descripción o Código"
                required
                #descRecorrido
              />
              <label for="descRecorrido">Chofer o Código de recorrido</label>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-between"
          style="border-top: 1px solid #dee2e6;"
        >
          <div></div>
          <button mdbBtn type="button" color="info" mdbWavesEffect>
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
          </button>
        </div>

        <table
          class="table table-striped table-hover table-sm align-middle mt-1"
        >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Código</th>
              <th scope="col">Descripción</th>
              <th scope="col">Chofer</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>21323123</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>0105234234</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
            <tr>
              <td>1111133333</td>
              <td>Descripción</td>
              <td>Chofer</td>
              <td>
                <button
                  mdbBtn
                  type="button"
                  color="indigo"
                  mdbWavesEffect
                  class="btn"
                  size="sm"
                >
                  Seleccionar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL despachar -->
<div
  mdbModal
  #despachar="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Despachar
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="despachar.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dato text-center">
            <h5>
              ¿Está seguro que desea <strong>despachar</strong> el recorrido
              <strong>Nro. XXX XXXX</strong> ?
            </h5>
            <h6><strong>Esta accción es irreversible</strong></h6>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="despachar.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
        <button
          type="button"
          class="btn btn-success waves-light"
          mdbWavesEffect
          (click)="despachar.hide()"
        >
          Sí, despachar.
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL verRecorridos -->
<div
  mdbModal
  #verRecorridos="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Ver recorrido
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="verRecorridos.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row filtros-body">
          <div class="col dato">
            <Strong class="title">Camión</Strong>
            <span class="value">XXXX-99</span>
          </div>
          <div class="col dato">
            <Strong class="title">Estado</Strong>
            <span class="value"
              ><mdb-badge pill="true" success="true"
                >Despachado</mdb-badge
              ></span
            >
          </div>
          <div class="col dato">
            <Strong class="title">Chofer</Strong>
            <span class="value">Juan Pérez</span>
          </div>
        </div>
        <table
          class="table table-striped table-hover table-sm align-middle mt-1"
        >
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Tipo Doc.</th>
              <th scope="col">Nro. Doc.</th>
              <th scope="col">items</th>
              <th scope="col">Monto</th>
              <th scope="col">RUT</th>
              <th scope="col">Cliente</th>
              <th scope="col">Vendedor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PE</td>
              <td>123123</td>
              <td>5</td>
              <td>$ 500.000</td>
              <td>99.999.999-9</td>
              <td>Jorge Rojas</td>
              <td>0001</td>
            </tr>
            <tr>
              <td>PE</td>
              <td>123123</td>
              <td>5</td>
              <td>$ 500.000</td>
              <td>99.999.999-9</td>
              <td>Jorge Rojas</td>
              <td>0001</td>
            </tr>
            <tr>
              <td>PE</td>
              <td>123123</td>
              <td>5</td>
              <td>$ 500.000</td>
              <td>99.999.999-9</td>
              <td>Jorge Rojas</td>
              <td>0001</td>
            </tr>
          </tbody>
        </table>

        <table class="table table-striped table-hover table-sm align-middle">
          <tbody class="blue lighten-5">
            <tr>
              <td><strong>Monto total</strong></td>
              <td>$ 1.500.000</td>
              <td><strong>Total documentos</strong></td>
              <td>15</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="verRecorridos.hide()"
          mdbWavesEffect
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
